
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SettingsTitleBar from '@components/settings/SettingsTitleBar.vue';
import SettingsPanel from '@components/settings/SettingsPanel.vue';
import TagIconPicker from '@components/settings/tag/TagIconPicker.vue';
import ColorPicker from '@components/settings/ColorPicker.vue';
import AppPage from '@components/new-styleguide/AppPage.vue';
import AppEditableHeader from '@components/new-styleguide/AppEditableHeader.vue';
import AppContent from '@components/new-styleguide/AppContent.vue';
import SettingsFooter from '@components/settings/SettingsFooter.vue';
import { IconNameTag, TagMutation } from '@/generated-clients/myTrips';
import IconColors from '@/config/IconColors';
import { Location } from 'vue-router';
import goBackWithFallback from '@util/goBackWithFallback';
import { RouterFrom } from '@/router/Routes';

const SettingsModule = namespace('Settings');
const RouterModule = namespace('Router');

@Component({
  name: 'TagAdd',
  components: {
    AppPage,
    AppContent,
    AppEditableHeader,
    SettingsPanel,
    SettingsFooter,
    SettingsTitleBar,
    TagIconPicker,
    ColorPicker
  }
})
export default class TagAdd extends Vue {
  @SettingsModule.Action('createTag')
  private createTag;

  @RouterModule.State('from')
  private from: RouterFrom;

  private tag: TagMutation = {
    name: '',
    iconName: IconNameTag.WorkIcon,
    color: ''
  }

  private disabled = false;
  private errorMessage = '';

  created() {
    this.tag.color = this.colors[0];
  }

  get backButton() {
    return { text: this.getCallbackTripId ? 'Zurück zur Fahrt' : 'Zurück zu Kategorien', location: this.backLocation };
  }

  get colors() {
    return IconColors.codes;
  }

  get nameError() {
    return this.tag.name.length === 0;
  }

  get errorsExist() {
    return this.nameError;
  }

  get getCallbackTripId() {
    return this.$route.query.tripId;
  }

  get backLocation(): Location {
    if (this.getCallbackTripId) {
      return { name: 'myTripsEdit', params: { id: String(this.getCallbackTripId) } };
    } else {
      return { name: 'tagsOverview' };
    }
  }

  private async submit() {
    if (!this.errorsExist) {
      this.errorMessage = '';
      this.disabled = true;

      try {
        const t = await this.createTag({ tag: this.tag });
        if (this.getCallbackTripId) {
          const backLoc = this.backLocation;
          backLoc.query = { tagId: t.id };
          goBackWithFallback(this.$router, !!this.from.name, backLoc, false, true);
        } else {
          goBackWithFallback(this.$router, !!this.from.name, this.backLocation);
        }
      } catch (error) {
        this.errorMessage = 'Fehler beim Speichern der Kategorie. Bitte versuchen sie es später erneut.'
      } finally {
        this.disabled = false;
      }
    }
  }
}
